import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DownloadDialogData} from '../case-detail/case-detail.component';

@Component({
  selector: 'app-program-guide',
  templateUrl: './download-mini-dialog.component.html',
  styleUrls: ['./download-mini-dialog.component.scss']
})
export class DownloadMiniDialogComponent implements AfterViewInit {
  @ViewChild('anchorTag', {static: false}) private anchorTag: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<DownloadMiniDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DownloadDialogData) {
  }

  ngAfterViewInit() {
    this.anchorTag.nativeElement.click();
    setTimeout(()=>{    
      this.dialogRef.close('done');
    }, 0);
  }

}
